"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getCostValue = function getCostValue(option) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cost';
  if (!option || !option[field]) return 0;
  var regexp = /\b\d*[,.]??\d+\b/g;
  var cost = option[field].match(regexp);
  return cost ? Number(cost[0]) : 0;
};
var _default = getCostValue;
exports["default"] = _default;